import React from 'react';
import DetailPage from './DetailPage';
import DetailPageHero from './DetailPageHero';
import DetailPageParagraph from './DetailPageParagraph';

const DetailPageAppleGames = () => {
  return (
    <DetailPage 
      title="Introducing the Apple Games App"
      heroSrc={'/images/apple-games/hero.png'}
      content="Apple Games is a new all-in-one destination that helps players jump back into the games they love, find their next favorite, and have more fun with friends, turning even single-player games into shared experiences. I designed the interaction model, navigation, and search experience for the Games app across iPhone, iPad, and Mac."
      year="2025"
      duration="2024 – 2025"
      role="Designer"
    >
        <DetailPageHero 
            src="/images/apple-games/Apple-WWDC25-Apple-Games-app_big.jpg.large_2x.jpg" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            At Apple's Worldwide Developers Conference (WWDC), Apple unveiled Apple Games, an all-new destination designed to help players jump back into the games they love, find their next favorite, and have more fun with friends. The Games app makes it easier than ever for players to enjoy all their games in one convenient place and see what's happening across their games, including major events and updates, so they never miss a moment.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/apple-games/Apple-WWDC25-Apple-Games-app-library_inline.jpg.large_2x.jpg" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            The Games app allows players to see all the games they have ever downloaded from the App Store for their iPhone and iPad, and brings together all the games they have on Mac. They can connect any compatible game controller for easy navigation around the app and to launch right into their games. Players can explore personalized recommendations based on games they've played, games their friends are playing, and games supporting Game Center features, that can be played together.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/apple-games/Apple-WWDC25-Apple-Games-app-recommendations_inline.jpg.large_2x.jpg" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            Editorial collections also appear in the app to help players find new games, including some of the most exciting games on the App Store, such as Balatro, Crashlands 2, and DREDGE. If they are an Apple Arcade subscriber, players will see curated collections of the best games included in the catalog that help them get the most out of their subscription.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/apple-games/Apple-WWDC25-Apple-Games-app-game-controllers_big.jpg.large_2x.jpg" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageHero 
            src="/images/apple-games/Apple-WWDC25-Apple-Games-app-Apple-Arcade-subscription_inline.jpg.large_2x.jpg" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            The Games app is also the best way to experience Apple Arcade, Apple's subscription service with more than 200 award-winning and highly rated games for the whole family, including Hello Kitty Island Adventure, Sneaky Sasquatch, and Mini Motorways.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/apple-games/Apple-WWDC25-Apple-Games-app-play-together_inline.jpg.large_2x.jpg" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            Players now have all their Game Center friends and groups they've played with in one place, so they can easily enjoy their games together. They can see their shared gaming history, compare achievements, and send friends invite links and party codes using any messaging app, bringing them right into a competition or multiplayer match.
        </DetailPageParagraph>

        <DetailPageHero 
            src="/images/apple-games/Apple-WWDC25-Apple-Games-app-challenges_inline.jpg.large_2x.jpg" 
            lazy={true}
            adaptiveAspectRatio
        />

        <DetailPageParagraph>
            The Games app introduces challenges, a new way to compete with friends in score-based showdowns. Developers that have Game Center leaderboards for their games can add these unique challenges that are catered to a smaller group of friends. Challenges can turn single-player games into shared experiences with friends, giving them even more ways to rally a group, crown a winner, and have a rematch.
        </DetailPageParagraph>
        
    </DetailPage>
  );
};

export default DetailPageAppleGames;

